import { Pipe, PipeTransform } from "@angular/core";
import { ConvertSpacesPipe } from "./convert-spaces.pipe";

/* Depends on ConvertSpacesPipe
 * Usage:
 *   value | stripHtml
 * Example:
 *   {{ '<a>a</a>' | stripHtml }}
 *   formats to: a
 */
@Pipe({ name: "stripHtml" })
export class StripHtmlTagsPipe implements PipeTransform {
  transform(html: string): string {
    return new ConvertSpacesPipe().transform(html.replace(/<\/?[^>]+>/gi, ""));
  }
}
